import { c as _c } from "react/compiler-runtime";
import styles from "./ReasonForVisit.module.css";
export const MottoAligners = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className={`${styles.reasonForVisitIcon} ${styles.reasonForVisitIconMotto}`}><img src="/assets/aspenscheduler/svgs/motto-aligners.svg" alt="" width={20} height={22} /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};